import { Button, Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { Drawer } from '@/components/modules/Drawer';
import { useDeleteAccount } from '@/modules/Customer/http/client/mutations/useDeleteAccount';

export const ConfirmDeleteAccountDrawer = () => {
  const t = useT();
  const { mutateAsync, isPending } = useDeleteAccount();

  return (
    <Drawer
      id={CONFIRM_DELETE_ACCOUNT_ID}
      headerContent={
        <Text size="2xl">{t('drawers.confirmDeleteAccount.header')}</Text>
      }
      closeButtonProps={{ top: '3.125rem' }}
      headerProps={{
        pl: '3.4375rem',
        pr: '3rem',
        py: '2.8125rem',
      }}
      bodyProps={{ px: '2xl' }}
    >
      <Flex flexDir="column" gap="3xl" pb="3xl">
        <Flex flexDir="column" gap="m">
          <Text size="h6" fontWeight="medium">
            {t('drawers.confirmDeleteAccount.title')}
          </Text>
          <Text size="xl">{t('drawers.confirmDeleteAccount.description')}</Text>
        </Flex>
        <Flex flexDir="column" gap="m">
          <Button
            justifyContent="center"
            onClick={() =>
              window.dispatchEvent(
                new CustomEvent(
                  `close-chakra-modal-${CONFIRM_DELETE_ACCOUNT_ID}`
                )
              )
            }
          >
            {t('attributes.cancel')}
          </Button>
          <Button
            variant="outline"
            onClick={async () => await mutateAsync()}
            isLoading={isPending}
          >
            {t('drawers.confirmDeleteAccount.confirmButton')}
          </Button>
        </Flex>
      </Flex>
    </Drawer>
  );
};

export const CONFIRM_DELETE_ACCOUNT_ID = 'confirm-delete-account';
